import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
    step: {
        personalInfo: {
            emailExtra: string;
        };
    };
};

export const messagesEN: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    step: {
        personalInfo: {
            emailExtra: 'Enter the Google account email you will use for your student membership. This must be the same account you were logged into when you opened this form.',
            subtitle: 'Please do not re-submit this form if you have a pending verification request.',
        },
    },
};
